import { render } from "./ParEmp.vue?vue&type=template&id=2b1dc4c2&scoped=true"
import script from "./ParEmp.vue?vue&type=script&lang=js"
export * from "./ParEmp.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=2b1dc4c2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1dc4c2"]])

export default __exports__